/**
 * @generated SignedSource<<114ff08e333106925db04337905f8693>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BlockID = {
  blockKey?: string | null;
  id?: string | null;
  noteId?: string | null;
};
export type AssignableDropdown_GetBlockShortURLMutation$variables = {
  blockId: BlockID;
};
export type AssignableDropdown_GetBlockShortURLMutation$data = {
  readonly NoteBlock_GetShortURL: {
    readonly url: string;
  } | null;
};
export type AssignableDropdown_GetBlockShortURLMutation = {
  response: AssignableDropdown_GetBlockShortURLMutation$data;
  variables: AssignableDropdown_GetBlockShortURLMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "blockId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "blockId",
        "variableName": "blockId"
      }
    ],
    "concreteType": "NoteBlockGetShortUrl",
    "kind": "LinkedField",
    "name": "NoteBlock_GetShortURL",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignableDropdown_GetBlockShortURLMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignableDropdown_GetBlockShortURLMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dcd3d3874ea320f46c6c021d567652f0",
    "id": null,
    "metadata": {},
    "name": "AssignableDropdown_GetBlockShortURLMutation",
    "operationKind": "mutation",
    "text": "mutation AssignableDropdown_GetBlockShortURLMutation(\n  $blockId: BlockID!\n) {\n  NoteBlock_GetShortURL(blockId: $blockId) {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "2271a88f242c79443f5e597a8820f4f4";

export default node;
